import { render, staticRenderFns } from "./BuilderSidebarTopnav.vue?vue&type=template&id=41a0af5b&scoped=true&"
import script from "./BuilderSidebarTopnav.vue?vue&type=script&lang=js&"
export * from "./BuilderSidebarTopnav.vue?vue&type=script&lang=js&"
import style0 from "./BuilderSidebarTopnav.vue?vue&type=style&index=0&id=41a0af5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a0af5b",
  null
  
)

export default component.exports